import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, ArrowLeft } from "lucide-react";
import { Logo } from "@/components/Logo";
import { paymentStatus } from "@/lib/api";
import { track } from "@/lib/analytics";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const session_id = params.get("session_id");
  const [status, setStatus] = useState({ payment_status: "pending" });
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (!session_id) return;
    let cancelled = false;
    const poll = async () => {
      try {
        const s = await paymentStatus(session_id);
        if (cancelled) return;
        setStatus(s);
        if (s.payment_status === "paid") {
          track("payment_succeeded", { kind: s.kind, amount: s.amount });
          return;
        }
        if (attempts > 20) return;
        setAttempts((a) => a + 1);
        setTimeout(poll, 2000);
      } catch (e) {
        if (cancelled) return;
        setTimeout(poll, 3000);
      }
    };
    poll();
    return () => {
      cancelled = true;
    };
  }, [session_id, attempts]);

  const paid = status.payment_status === "paid";

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-6">
      <div className="max-w-lg w-full text-center space-y-8">
        <Logo variant="dark" size="lg" />
        <div className="flex flex-col items-center space-y-6">
          <CheckCircle2 size={56} strokeWidth={1} className={paid ? "text-[#0B192C]" : "text-neutral-400"} />
          <div className="sc-overline">{paid ? "Sostegno confermato" : "In elaborazione"}</div>
          <h1 className="font-display font-light text-4xl" style={{ letterSpacing: "-0.02em" }}>
            {paid ? "Sei un co-finanziatore." : "Verifica in corso..."}
          </h1>
          <p className="text-sm text-neutral-500 leading-relaxed max-w-md">
            {paid
              ? "I fondi sono stati depositati in conto escrow. Riceverai il tuo voucher via email al completamento dei lavori."
              : "Stiamo confermando il tuo pagamento presso Stripe. Non chiudere questa pagina."}
          </p>
          {session_id && (
            <div className="text-[11px] text-neutral-400 font-mono">Session: {session_id.slice(0, 24)}...</div>
          )}
        </div>
        <Link to="/" className="sc-btn-ghost inline-flex items-center gap-2" data-testid="back-home-btn">
          <ArrowLeft size={14} /> Torna alla home
        </Link>
      </div>
    </div>
  );
}
